import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/global.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faInstagram, faEnvelope, faFacebook);

createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(router).mount('#app');
